import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { SalesExpenseActionTypes, SalesExpenseActions } from "../../../actionTypes/sales/saleExpenseActionTypes";
import { createSalesExpenseApi, editSalesExpenseDataByIdApi, getMySalesExpenseListApi, getSalesExpenseDataByIdApi, getSalesExpenseListApi, updateSalesExpenseStatusApi } from "../../requests/sales/salesExpenseRequests";
import { setMySalesExpenseList, setMySalesExpenseListPageCount, setSalesExpenseDataById, setSalesExpenseList, setSalesExpenseListPageCount } from "../../../actions/sales/salesExpenseActions";

function* createSalesExpenseHandler(action: SalesExpenseActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createSalesExpenseApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getSalesExpenseListHandler(action: SalesExpenseActionTypes) {
  if(action.payload.search){
    yield delay(500);
  }
  try {
    yield startLoader("transparent");
    const { data } = yield call(getSalesExpenseListApi, action.payload);

    if (data.status) {
      const fallbackData = [
        {
          id: 0,
          bill_img: "",
          expense_value: 0,
          expense_type: "",
          employee_id: 0,
          request_closed_by: null,
          sales_activity_id: null,
          created_by: null,
          branch_id: null,
          status: "",
          description: "",
          createdAt: null,
          updatedAt: null,
          branch_data: {
            id: 0,
            branch_code: "",
            branch_name: "",
            hub_id: null,
            location: "",
            email: null ,
            address: null ,
            pincode: null,
            contact_number: "",
            gstin: "",
            contact_person_id: null,
            gps_location: null,
            created_by: null,
            createdAt: null,
            updatedAt: null,
            hub: {
              id: null,
              hub_name: "",
              slug: "",
              hub_code: "",
              location: "",
              address: "",
              email: null,
              contact_number: null,
              created_by: null,
              createdAt: null,
              updatedAt: null,
            },
          },
        }
      ]
      yield put(setSalesExpenseList(data?.data?.rows || fallbackData));
      yield put(setSalesExpenseListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getMySalesExpenseListHandler(action: SalesExpenseActionTypes) {
  if(action.payload.search){
    yield delay(500);
  }
  try {
    yield startLoader("transparent");
    const { data } = yield call(getMySalesExpenseListApi, action.payload);

    if (data.status) {
      const fallbackData = [
        {
          id: 0,
          bill_img: "",
          expense_value: 0,
          expense_type: "",
          employee_id: 0,
          request_closed_by: null,
          sales_activity_id: null,
          created_by: null,
          branch_id: null,
          status: "",
          description: "",
          createdAt: null,
          updatedAt: null,
          branch_data: {
            id: 0,
            branch_code: "",
            branch_name: "",
            hub_id: null,
            location: "",
            email: null ,
            address: null ,
            pincode: null,
            contact_number: "",
            gstin: "",
            contact_person_id: null,
            gps_location: null,
            created_by: null,
            createdAt: null,
            updatedAt: null,
            hub: {
              id: null,
              hub_name: "",
              slug: "",
              hub_code: "",
              location: "",
              address: "",
              email: null,
              contact_number: null,
              created_by: null,
              createdAt: null,
              updatedAt: null,
            },
          },
        }
      ]
      yield put(setMySalesExpenseList(data?.data?.rows || fallbackData));
      yield put(setMySalesExpenseListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getSalesExpenseDataByIdHandler(action: SalesExpenseActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getSalesExpenseDataByIdApi, action.payload);
    if (data.status) {
      yield put(setSalesExpenseDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editSalesExpenseDataByIdHandler(action: SalesExpenseActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editSalesExpenseDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* updateSalesExpenseStatusHandler(action: SalesExpenseActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(updateSalesExpenseStatusApi, action.payload);
    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      window.location.reload()
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// lead sagas
export default function* salesExpenseSaga() {
  yield takeLatest(SalesExpenseActions.CREATE_SALES_EXPENSE, createSalesExpenseHandler);
  yield takeLatest(SalesExpenseActions.GET_SALES_EXPENSE_LIST, getSalesExpenseListHandler);
  yield takeLatest(SalesExpenseActions.GET_MY_SALES_EXPENSE_LIST, getMySalesExpenseListHandler);
  yield takeLatest(SalesExpenseActions.GET_SALES_EXPENSE_DATA_BY_ID, getSalesExpenseDataByIdHandler);
  yield takeLatest(SalesExpenseActions.EDIT_SALES_EXPENSE_DATA_BY_ID, editSalesExpenseDataByIdHandler);
  yield takeLatest(SalesExpenseActions.UPDATE_SALES_EXPENSE_STATUS, updateSalesExpenseStatusHandler);
}
